export const color = {
  theme: 'red',
  // linear-gradient(#e66465, #9198e5);
  edit: '#ff7b54',
  submit: '#7eca9c',
  clear: '#707070',
  remove: '#d35d6e',
  search: '#1890ff',
  red: '#FF0000',
  logout: '#737373',
  gray: '#737373',
  light_gray: '#E5E5E5',
  light_blue: '#E2F6FF',
  blueFocus: '#2BB3E7',
  blackFocus: '#000000',
  whiteFocus: '#FFFFFF',
  yellow: '#F4D35E',
  content_background: '#F8F8F8',
  white: '#FFFFFF',
  dark: '#5d5b5b',
  bg_yellow: '#fef60029',
  bg_orange: '#f99f4729',
  bg_gray: '#98989a29',
  bg_blue: '#2f54eb29',
  bg_red: '#ff000029',
};
